<div
  *ngIf="{jobseekerWorkExperience: jobseekerWorkExperience$ | async,
             monthList: monthList$ | async,
             selectedFile: selectedFile$ | async,
             isFileUploading: isFileUploading$ | async,
             selectedSpecializationIds: selectedSpecializationIds$ | async,
             selectedSpecializations: selectedSpecializations$ | async,
             selectedCategories: selectedCategories$ | async,
             hasAttachment: selectHasAttachment$ | async,
             selectedCategoryIds: selectedCategoryIds$ | async,
             selectedIndustryIds: selectedIndustryIds$ | async,
             selectedIndustries: selectIndustries$ | async,
             employmentFormTypeItems: employmentFormTypeItems$ | async,
             workScheduleItems: workScheduleItems$ | async,
             selectedWorkSchedule: selectedWorkSchedule$ | async,
             selectedEmploymentFormNew: selectedEmploymentFormNew$ | async,
             isCurrent: isCurrent$ | async,
             isFormSubmitted: isFormSubmitted$ | async,
             enableAddLocationButton: isAddLocationEnabled$ |async,
             isUpdating: isUpdating$ | async,
             seniorityLevelItems: seniorityLevelItems$ | async,
             selectedSeniorityLevelId: selectedSeniorityLevelId$ | async,
             employmentFormType: employmentFormTypes$ | async,
             selectedFileText: selectedFileText$ | async,
             systemConfigs: systemConfigs$ | async,
             isFileSizeValid: isFileSizeValid$ | async,
             jobseekerId: jobseekerId$ | async,
             moderationLastChangeDate: moderationLastChangeDate$ | async,
             locationLevelCount: locationLevelCount$ | async,
             locationRequiredLevelCount: locationRequiredLevelCount$ | async,
             locationLastHiddenLevelCount: locationLastHiddenLevelCount$ | async,
             firstLevelParentLocationId: locationFirstLevelId$ | async,
            } as data"
>
  <app-spinner [isLoading]="isUpdating$ | async" [isFixedPosition]="false">
    <form
      [formGroup]="editForm"
      #ngForm="ngForm"
      [appConnectForm]="data.jobseekerWorkExperience"
      class="form"
    >
      <div mat-dialog-title class="title">{{ title | translate }}</div>

      <mat-dialog-content #scrollContainer>
        <div class="form-item position">
          <label class="form-item__label position__label">{{
            'label.PositionJobTitle' | translate
          }}</label>
          <div>
            <input
              class="form-item__value position__value"
              maxlength="200"
              type="text"
              formControlName="positionTitle"
              name="positionTitle"
            />
            <mat-error
              class="validation-message"
              *ngIf="
                editForm.controls['positionTitle'].hasError('required') &&
                (editForm.controls['positionTitle'].touched ||
                  data.isFormSubmitted)
              "
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
          </div>
        </div>

        <div class="form-item specialization-container">
          <label class="form-item__label">{{
            'label.SpecializationPosition' | translate
          }}</label>
          <div class="specializations">
            <div class="specializations__button-container">
              <button
                (click)="specializationPicker(data.selectedSpecializationIds)"
                class="specializations__button-container__button"
                type="button"
                [class.has-error]="
                  data.selectedSpecializationIds?.length === 0 &&
                  (specializationButtonIsTouched || ngForm.submitted)
                "
              >
                {{ 'label.SelectSpecializationSpecialty' | translate }}
              </button>

              <div class="keyword-search-info-icon">
                <span
                  matTooltip="{{
                    'text.WorkSpecializationSpecialty' | translate
                  }}"
                >
                  <svg-icon
                    src="/assets/icons/info-circle.svg"
                    [svgStyle]="{
                      display: 'flex',
                      'justify-content': 'center',
                      'align-items': 'center'
                    }"
                  ></svg-icon>
                </span>
              </div>

              <svg-icon
                [src]="'/assets/icons/required.svg'"
                class="required-icon"
              ></svg-icon>
            </div>

            <div
              *ngFor="let headSpecializations of data?.selectedSpecializations"
              class="specializations__list"
            >
              <span class="specializations__head"
                >{{ headSpecializations.head }}:
              </span>
              <span class="specializations__sub">
                <span
                  *ngFor="
                    let specialization of headSpecializations.subSpecializations;
                    let last = last
                  "
                >
                  {{ specialization }}{{ last ? '' : '; ' }}
                </span>
              </span>
            </div>

            <div>
              <mat-error
                class="validation-message"
                *ngIf="
                  data.selectedSpecializationIds?.length === 0 &&
                  (specializationButtonIsTouched || ngForm.submitted)
                "
                >{{ 'message.MandatoryField' | translate }}</mat-error
              >
            </div>
          </div>
        </div>

        <div class="form-item employer">
          <label class="form-item__label employer__label"
            >{{ 'label.CompanyEmployer' | translate }}
          </label>
          <div>
            <div class="employer-input-container">
              <input
                class="form-item__value employer__value"
                maxlength="200"
                type="text"
                formControlName="employer"
                name="employer"
              />
              <svg-icon
                [src]="'assets/icons/required.svg'"
                class="required-icon"
              ></svg-icon>
            </div>
            <mat-error
              class="validation-message"
              *ngIf="
                (editForm.controls['employer'].touched || ngForm.submitted) &&
                editForm.controls['employer'].hasError('required')
              "
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
          </div>
        </div>

        <div class="form-item industry-container">
          <label class="form-item__label">{{
            'label.IndustryField' | translate
          }}</label>
          <div class="industries">
            <div class="industries__button-container">
              <button
                (click)="industryPicker(data.selectedIndustryIds)"
                class="industries__button-container__button"
                type="button"
                [class.has-error]="
                  data.selectedIndustryIds?.length === 0 &&
                  (industryButtonIsTouched || ngForm.submitted)
                "
              >
                {{ 'label.SelectPositionIndustries' | translate }}
              </button>

              <div class="keyword-search-info-icon">
                <span matTooltip="{{ 'text.WorkIndustryField' | translate }}">
                  <svg-icon
                    src="/assets/icons/info-circle.svg"
                    [svgStyle]="{
                      display: 'flex',
                      'justify-content': 'center',
                      'align-items': 'center'
                    }"
                  ></svg-icon>
                </span>
              </div>

              <svg-icon
                [src]="'/assets/icons/required.svg'"
                class="required-icon"
              ></svg-icon>
            </div>

            <div
              *ngFor="let headIndustry of data?.selectedIndustries"
              class="industries__list"
            >
              <span class="industries__head">{{ headIndustry.head }}: </span>
              <span class="industries__sub">
                <span
                  *ngFor="
                    let industry of headIndustry.subindustries;
                    let last = last
                  "
                >
                  {{ industry }}{{ last ? '' : '; ' }}
                </span>
              </span>
            </div>

            <div>
              <mat-error
                class="validation-message"
                *ngIf="
                  data.selectedIndustryIds?.length === 0 &&
                  (industryButtonIsTouched || ngForm.submitted)
                "
                >{{ 'message.MandatoryField' | translate }}</mat-error
              >
            </div>
          </div>
        </div>

        <div class="form-item seniority-level">
          <label class="form-item__label seniority-level__label">{{
            'label.SeniorityLevel' | translate
          }}</label>
          <div class="seniority-level__value">
            <div class="seniority-level__value__container">
              <p-select
                [(ngModel)]="data.selectedSeniorityLevelId"
                #seniorityLevelControl="ngModel"
                [ngModelOptions]="{ standalone: true }"
                [options]="data.seniorityLevelItems"
                [styleClass]="
                  data.selectedSeniorityLevelId
                    ? 'select-container-selected'
                    : 'select-container'
                "
                optionLabel="name"
                optionValue="id"
                [class.has-error]="
                  !data.selectedSeniorityLevelId &&
                  (seniorityLevelControl.touched || ngForm.submitted)
                "
                [showClear]="data.selectedSeniorityLevelId"
                (onChange)="onSelectSeniorityLevel($event)"
              >
                <ng-template pTemplate="selectedItem" let-item>
                  <span *ngIf="item">{{ item.name }}</span>
                </ng-template>

                <ng-template pTemplate="item" let-item>
                  <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                  <svg-icon
                    src="/assets/icons/arrow-down.svg"
                    [svgStyle]="{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }"
                  ></svg-icon>
                </ng-template>

                <ng-template #clearicon>
                  <svg-icon
                    src="/assets/icons/close-small.svg"
                    [svgStyle]="{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }"
                  ></svg-icon>
                </ng-template>
              </p-select>

              <div class="keyword-search-info-icon">
                <span
                  matTooltip="{{ 'text.SelectWorkSeniorityLevel' | translate }}"
                >
                  <svg-icon
                    src="/assets/icons/info-circle.svg"
                    [svgStyle]="{
                      display: 'flex',
                      'justify-content': 'center',
                      'align-items': 'center'
                    }"
                  ></svg-icon>
                </span>
              </div>
              <svg-icon
                [src]="'assets/icons/required.svg'"
                class="required-icon"
              ></svg-icon>
            </div>
            <mat-error
              *ngIf="
                !data.selectedSeniorityLevelId &&
                (seniorityLevelControl.touched || ngForm.submitted)
              "
              class="validation-message"
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
          </div>
        </div>

        <div class="form-item employment-form-type">
          <label class="form-item__label employment-form-type__label">{{
            'label.EmploymentForm' | translate
          }}</label>
          <div class="employment-form-type__value">
            <div class="employment-form-type__value__container">
              <p-select
                [(ngModel)]="data.selectedEmploymentFormNew"
                #employmentFormTypeControl="ngModel"
                [ngModelOptions]="{ standalone: true }"
                [options]="data.employmentFormTypeItems"
                [styleClass]="
                  data.selectedEmploymentFormNew
                    ? 'select-container-selected'
                    : 'select-container'
                "
                optionLabel="name"
                optionValue="id"
                [class.has-error]="
                  !data.selectedEmploymentFormNew &&
                  (employmentFormTypeControl.touched || ngForm.submitted)
                "
                [showClear]="data.selectedEmploymentFormNew"
                (onChange)="onSelectEmploymentFormNew($event)"
              >
                <ng-template pTemplate="selectedItem" let-item>
                  <span *ngIf="item">{{ item.name }}</span>
                </ng-template>

                <ng-template pTemplate="item" let-item>
                  <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                  <svg-icon
                    src="/assets/icons/arrow-down.svg"
                    [svgStyle]="{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }"
                  ></svg-icon>
                </ng-template>

                <ng-template #clearicon>
                  <svg-icon
                    src="/assets/icons/close-small.svg"
                    [svgStyle]="{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }"
                  ></svg-icon>
                </ng-template>
              </p-select>

              <div class="keyword-search-info-icon">
                <span
                  matTooltip="{{ 'text.SelectEmploymentFormType' | translate }}"
                >
                  <svg-icon
                    src="/assets/icons/info-circle.svg"
                    [svgStyle]="{
                      display: 'flex',
                      'justify-content': 'center',
                      'align-items': 'center'
                    }"
                  ></svg-icon>
                </span>
              </div>
              <svg-icon
                [src]="'assets/icons/required.svg'"
                class="required-icon"
              ></svg-icon>
            </div>

            <mat-error
              *ngIf="
                !data.selectedEmploymentFormNew &&
                (employmentFormTypeControl.touched || ngForm.submitted)
              "
              class="validation-message"
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
          </div>
        </div>

        <div class="form-item work-schedule">
          <label class="form-item__label work-schedule__label">{{
            'label.Schedule' | translate
          }}</label>
          <div class="work-schedule__value">
            <div class="work-schedule__value__container">
              <p-select
                [(ngModel)]="data.selectedWorkSchedule"
                #workScheduleControl="ngModel"
                [ngModelOptions]="{ standalone: true }"
                [options]="data.workScheduleItems"
                [styleClass]="
                  data.selectedWorkSchedule
                    ? 'select-container-selected'
                    : 'select-container'
                "
                optionLabel="name"
                optionValue="id"
                [class.has-error]="
                  !data.selectedWorkSchedule &&
                  (workScheduleControl.touched || ngForm.submitted)
                "
                [showClear]="data.selectedWorkSchedule"
                (onChange)="onSelectWorkSchedule($event)"
              >
                <!-- Selected value -->
                <ng-template pTemplate="selectedItem" let-item>
                  <span *ngIf="item">{{ item.name }}</span>
                </ng-template>

                <!-- Dropdown items -->
                <ng-template pTemplate="item" let-item>
                  <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                  <svg-icon
                    src="/assets/icons/arrow-down.svg"
                    [svgStyle]="{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }"
                  ></svg-icon>
                </ng-template>

                <ng-template #clearicon>
                  <svg-icon
                    src="/assets/icons/close-small.svg"
                    [svgStyle]="{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }"
                  ></svg-icon>
                </ng-template>
              </p-select>

              <div class="keyword-search-info-icon">
                <span matTooltip="{{ 'text.SelectWorkSchedule' | translate }}">
                  <svg-icon
                    src="/assets/icons/info-circle.svg"
                    [svgStyle]="{
                      display: 'flex',
                      'justify-content': 'center',
                      'align-items': 'center'
                    }"
                  ></svg-icon>
                </span>
              </div>
              <svg-icon
                [src]="'assets/icons/required.svg'"
                class="required-icon"
              ></svg-icon>
            </div>

            <mat-error
              *ngIf="
                !data.selectedWorkSchedule &&
                (workScheduleControl.touched || ngForm.submitted)
              "
              class="validation-message"
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
          </div>
        </div>

        <div
          class="form-item locality"
          *ngIf="
            data.locationLevelCount &&
            data.locationRequiredLevelCount &&
            data.firstLevelParentLocationId
          "
        >
          <div class="locality-label-container">
            <label class="form-item__label locality__label">{{
              'label.Locality' | translate
            }}</label>
            <div class="keyword-search-info-icon">
              <span matTooltip="{{ 'text.SelectLocationType' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>

          <div class="employment-form-checkbox form-item">
            <mat-radio-group
              class="employment-form"
              formControlName="employmentFormTypeId"
            >
              <div *ngFor="let option of data.employmentFormType">
                <mat-radio-button
                  (change)="updateEmploymentFormType($event)"
                  class="type__option"
                  [value]="option.announcementEmploymentFormTypeId"
                  >{{ option.name }}</mat-radio-button
                >
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="
                ngForm.hasError('employmentTypeRequired') &&
                (ngForm.control['employmentFormTypeId'].touched ||
                  data.isFormSubmitted)
              "
              class="validation-message"
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
          </div>
          <div
            *ngIf="
              editForm.get('employmentFormTypeId')?.value !==
              employmentFormTypeEnum.WorkFromHome
            "
          >
            <div
              formArrayName="extendedLocationPathList"
              class="form-item__value locality__value"
              *ngFor="
                let extendedLocation of locationControl.controls;
                let i = index
              "
            >
              <hrra-location-picker
                [formControlName]="i"
                [rowStyled]="true"
                [locationLevelCount]="data.locationLevelCount"
                [firstLevelParentLocationId]="data.firstLevelParentLocationId"
                [requiredLevelCount]="data.locationRequiredLevelCount"
                [lastHiddenLevelCount]="data.locationLastHiddenLevelCount"
                [class.has-error]="
                  editForm.get('employmentFormTypeId')?.value !==
                    employmentFormTypeEnum.WorkFromHome &&
                  (editForm.hasError('SameExtendedLocation') ||
                    editForm.hasError('ExtendedLocationsRequired') ||
                    editForm.controls['extendedLocationPathList'].hasError(
                      'maxlength'
                    )) &&
                  (editForm.controls['extendedLocationPathList'].touched ||
                    ngForm.submitted)
                "
                style="width: 100%"
              >
              </hrra-location-picker>
              <div class="location-buttons">
                <button
                  class="location-buttons__reset"
                  (click)="resetLocation(i)"
                >
                  <svg-icon
                    [svgClass]="'reset-icon'"
                    [src]="'/assets/icons/reset.svg'"
                  ></svg-icon>
                </button>
                <button
                  class="location-buttons__remove"
                  (click)="removeLocation(i)"
                  *ngIf="i > 0"
                >
                  <svg-icon
                    [svgClass]="'delete-icon'"
                    [src]="'/assets/icons/delete-red.svg'"
                  ></svg-icon>
                </button>
              </div>
            </div>
          </div>

          <mat-error
            *ngIf="
              editForm.hasError('SameExtendedLocation') &&
              editForm.get('employmentFormTypeId')?.value !==
                employmentFormTypeEnum.WorkFromHome &&
              (editForm.controls['extendedLocationPathList'].touched ||
                ngForm.submitted)
            "
            class="validation-message-location"
          >
            {{ 'message.SameExtendedLocation' | translate }}
          </mat-error>

          <mat-error
            *ngIf="
              editForm.hasError('ExtendedLocationsRequired') &&
              editForm.get('employmentFormTypeId')?.value !==
                employmentFormTypeEnum.WorkFromHome &&
              (editForm.controls['extendedLocationPathList'].touched ||
                ngForm.submitted)
            "
            class="validation-message-location"
          >
            {{ 'message.MandatoryField' | translate }}
          </mat-error>

          <mat-error
            *ngIf="
              editForm.controls['extendedLocationPathList'].hasError(
                'maxlength'
              ) &&
              editForm.get('employmentFormTypeId')?.value !==
                employmentFormTypeEnum.WorkFromHome &&
              (editForm.controls['extendedLocationPathList'].touched ||
                ngForm.submitted)
            "
            class="validation-message-location"
          >
            {{
              'message.ExtendedLocationMaxCountMessage'
                | translate: { count: data.extenededLocationMaxCount }
            }}
          </mat-error>
        </div>
        <div
          class="new-location"
          *ngIf="
            data.enableAddLocationButton &&
            editForm.get('employmentFormTypeId')?.value !==
              employmentFormTypeEnum.WorkFromHome
          "
        >
          <button class="new-location__button" (click)="addNewLocation()">
            <svg-icon
              class="new-location__icon"
              src="/assets/icons/plus-small.svg"
            ></svg-icon>
            {{ 'label.NewLocation' | translate }}
          </button>
        </div>

        <div>
          <div class="dates">
            <div class="form-item date-from">
              <label class="form-item__label date-from__label">{{
                'label.StartDate' | translate
              }}</label>
              <div class="date-from__value">
                <select
                  class="form-item__value date-from__value-month"
                  formControlName="dateFromMonth"
                >
                  <option [ngValue]="null">
                    {{ 'label.MonthLabel' | translate }}
                  </option>
                  <option
                    *ngFor="let month of data.monthList"
                    [ngValue]="month.value"
                  >
                    {{ month.name }}
                  </option>
                </select>

                <div>
                  <input
                    class="form-item__value date-from__value-year"
                    maxlength="4"
                    type="text"
                    formControlName="dateFromYear"
                    name="dateFromYear"
                    placeholder="{{ 'label.Year' | translate: { count: 1 } }}"
                  />
                  <mat-error
                    *ngIf="
                      editForm.controls['dateFromYear'].hasError('required') &&
                      (editForm.controls['dateFromYear'].touched ||
                        data.isFormSubmitted)
                    "
                    >{{ 'message.MandatoryField' | translate }}</mat-error
                  >
                  <mat-error
                    *ngIf="
                      editForm.controls['dateFromYear'].hasError('pattern') &&
                      (editForm.controls['dateFromYear'].touched ||
                        data.isFormSubmitted)
                    "
                    >{{ 'message.IncorrectFormat' | translate }}</mat-error
                  >
                </div>
              </div>
            </div>

            <div class="form-item date-to">
              <label class="form-item__label date-to__label">{{
                'label.EndDate' | translate
              }}</label>
              <div class="date-to__value">
                <select
                  [attr.disabled]="data?.isCurrent ? '' : null"
                  class="form-item__value date-to__value-month"
                  formControlName="dateToMonth"
                >
                  <option [ngValue]="null">
                    {{ 'label.MonthLabel' | translate }}
                  </option>
                  <option
                    *ngFor="let month of data.monthList"
                    [ngValue]="month.value"
                  >
                    {{ month.name }}
                  </option>
                </select>

                <div>
                  <input
                    [attr.disabled]="data?.isCurrent ? '' : null"
                    maxlength="4"
                    type="text"
                    class="form-item__value date-to__value-year"
                    formControlName="dateToYear"
                    name="dateToYear"
                    placeholder="{{ 'label.Year' | translate: { count: 1 } }}"
                  />
                  <mat-error
                    *ngIf="
                      editForm.hasError('RequiredYear') && data.isFormSubmitted
                    "
                    >{{ 'message.MandatoryField' | translate }}</mat-error
                  >
                  <mat-error
                    *ngIf="
                      editForm.controls['dateToYear'].hasError('pattern') &&
                      (editForm.controls['dateToYear'].touched ||
                        data.isFormSubmitted)
                    "
                    >{{ 'message.IncorrectFormat' | translate }}</mat-error
                  >
                </div>
              </div>
              <mat-error
                class="error error--date-to"
                *ngIf="
                  editForm.hasError('date') &&
                  (editForm.controls['dateToYear'].touched ||
                    data.isFormSubmitted) &&
                  editForm.controls['dateToYear'].valid &&
                  editForm.controls['dateFromYear'].valid
                "
              >
                {{ 'message.StartDateMustNotComeAfterEndDate' | translate }}
              </mat-error>
            </div>

            <div class="form-item currently-work">
              <mat-checkbox
                (click)="onCurrentExperience(data?.isCurrent)"
                formControlName="isCurrent"
                >{{ 'label.ICurrentlyWorkHere' | translate }}</mat-checkbox
              >
            </div>
          </div>
        </div>

        <div class="form-item description">
          <label class="form-item__label description__label">{{
            'label.JobDescription' | translate
          }}</label>
          <textarea
            class="form-item__value description__value"
            type="text"
            formControlName="description"
            placeholder="({{ 'text.EnterShortListOfDuties' | translate }})"
          ></textarea>
        </div>

        <input
          type="file"
          style="display: none"
          #hiddenfileinput
          (change)="
            onFileSelect(
              $event,
              data.systemConfigs.jobseeker.jobseekerAttachmentMaxSize
            )
          "
        />
        <div *ngIf="!data.hasAttachment" class="form-item attachment">
          <app-advanced-button
            (click)="hiddenfileinput.click()"
            [iconType]="iconButtonType.attachment"
            [isIconEnabled]="false"
            [text]="'label.AttachDocument' | translate"
            [type]="'midnight-blue'"
            class="attachment__btn"
          ></app-advanced-button>

          <button
            (click)="hiddenfileinput.click()"
            class="attachment__choose-btn"
            type="button"
          >
            {{ 'label.Select' | translate }}
          </button>
          <div
            *ngIf="data.selectedFile?.filename != null"
            class="selected-file"
          >
            {{ data.selectedFileText }}
          </div>
          <span class="attachment__choose-text"
            >({{ 'label.EgRecommendationLetter' | translate }})</span
          >
        </div>
        <div *ngIf="data.hasAttachment" class="form-item attachment">
          <app-advanced-button
            (click)="
              downloadAttachment(data.jobseekerWorkExperience?.experienceId)
            "
            [iconType]="iconButtonType.attachment"
            [text]="'label.Attachment' | translate"
            [type]="'blue'"
            class="attachment__btn attachment__btn--uploaded"
          ></app-advanced-button>
          <!-- not added yet -->
          <!-- <button class="attachment__delete" type="button">
          {{ 'label.Delete' | translate }}
        </button> -->
          <button
            (click)="hiddenfileinput.click()"
            class="attachment__replace"
            type="button"
          >
            {{ 'label.Change' | translate }}
          </button>
          <div
            *ngIf="data.selectedFile?.filename != null"
            class="selected-file"
          >
            {{ data.selectedFileText }}
          </div>
        </div>
        <mat-progress-bar
          *ngIf="data.isFileUploading"
          mode="indeterminate"
        ></mat-progress-bar>
        <div
          *ngIf="!data.isFileSizeValid && data.isFileSizeValid != null"
          class="attachment-size-validation"
        >
          <mat-error>
            {{ 'message.JobseekerFileSizeValidation' | translate }}
          </mat-error>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <div class="buttons">
          <app-button
            [ngClass]="{ disabled: editForm.invalid }"
            type="submit"
            (click)="
              onSave(
                data.selectedFile?.filename,
                data?.selectedCategoryIds,
                data.selectedIndustryIds,
                data?.selectedSpecializationIds,
                data.selectedSeniorityLevelId,
                data.selectedEmploymentFormNew,
                data.selectedWorkSchedule,
                data.isFileSizeValid,
                data.jobseekerId,
                data.moderationLastChangeDate
              )
            "
            [text]="'label.Save' | translate"
            [type]="buttonType.coloured"
            [typeAttribute]="buttonAttributeType.submit"
            class="button-save"
          ></app-button>
          <app-button
            [mat-dialog-close]="true"
            [text]="'label.Cancel' | translate"
            [type]="buttonType.uncoloured"
            [typeAttribute]="buttonAttributeType.button"
          ></app-button>
        </div>
      </mat-dialog-actions>
    </form>
  </app-spinner>
</div>
